import { type MetricField } from "../../gql-generated/types";
import { getKeys } from "../../shared/utils/object";
import { type InsightsMetrics, type InsightsMetricsMap, type StatsItem } from "../models";

export const mapAverageValues = (
    metrics: Partial<Record<MetricField, InsightsMetrics<StatsItem>>>,
): InsightsMetricsMap<StatsItem> => {
    getKeys(metrics).forEach((item: MetricField) => {
        const metric = metrics[item];
        if (metric) {
            metric.averageValue = metric.totalValue / metric.stats.length;
        }
    });

    return metrics;
};
